import React from 'react';
import Button from 'src/components/Button/Button';
import FontAwesomeIcon from 'src/components/Icon';
import './calcom-booking-view-button.scss';

const buildCalcomBookingUrl = (bookingUid: string): string =>
  `https://cal.com/booking/${bookingUid}?changes=true`;

const CANCELLED_BUTTON_STYLE: React.CSSProperties = {
  backgroundColor: '#dc2626',
};

interface CalcomBookingViewButtonProps {
  bookingUid: string | null | undefined;
  isCancelled?: boolean;
}

const CalcomBookingViewButton = ({
  bookingUid,
  isCancelled = false,
}: CalcomBookingViewButtonProps) => {
  if (!bookingUid) {
    return null;
  }

  return (
    <a
      className="calcom-booking-view-button"
      href={buildCalcomBookingUrl(bookingUid)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Button
        type="button"
        color="teal"
        size="small"
        label="View in Cal.com"
        style={isCancelled ? CANCELLED_BUTTON_STYLE : undefined}
        icon={
          <FontAwesomeIcon glyph="external-link" weight="light" size="small" />
        }
      />
    </a>
  );
};

export default CalcomBookingViewButton;